module.exports = __webpack_public_path__ + "static/media/IRON-USDC.81a4472d.png";